module.exports = __webpack_public_path__ + "img/switch-thumb.b8e39b50.svg";